import { render, staticRenderFns } from "./calendarEventEditDialog.vue?vue&type=template&id=3652b816&"
import script from "./calendarEventEditDialog.vue?vue&type=script&lang=js&"
export * from "./calendarEventEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports